import React, { useState, useEffect, useMemo } from "react";
import { FormControl, MenuItem, Menu } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "@mui/material";
import axios from "axios";
import { setUsers } from "../../../redux/actions/usersActions";
import useFetch from "../../../funcrions/DataFetchers";
import Table from "../../../utils/Table";
import moment from "moment/moment";
import { useDebounce } from "use-debounce"; // ✅ added for debounce search

const Users = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState("");
  const token = useSelector((state) => state.token.token);

  const columns = [
    { title: "User Name", field: "name", width: "2%" },
    { title: "Username", field: "username" },
    { title: "Phone", field: "phone" },
    { title: "Nuuca", field: "usageType" },
    { title: "Registration Fee", field: "registrationFee" },
    {
      title: "Created Date",
      field: "created_at",
      render: (data) => (
        <p>{moment(data.created_at).format("DD/MM/YYYY")}</p>
      ),
    },
    { title: "User Fee", field: "fee" },
    { title: "Location", field: "businessLocation" },
    { title: "2nd Number", field: "businessNumber" },
    {
      title: "Notify",
      field: "notify",
      render: (data) => (
        <p
          style={{
            color: data.notify == "stuck" && "red",
            fontWeight: data.notify == "stuck" && "bold",
          }}
        >
          {data.notify}
        </p>
      ),
    },
  ];

  const parentDivStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "0px",
    padding: "20px",
    background: "white",
    width: "95%",
    margin: "auto",
    marginTop: "20px",
    borderRadius: "8px 8px 0px 0px",
  };

  const searchStyle = {
    width: "400px",
    height: "40px",
    padding: "10px",
    fontSize: "16px",
    borderRadius: "8px",
    background: "#EFF0F6",
    border: "none",
  };

  const selectStyle = {
    height: "40px",
    color: "#B9B9B9",
    width: "150px",
  };

  const statusArr = ["All", "Active", "Inactive"];
  const [status, setStatus] = useState(statusArr[0]);
  const [query, setQuery] = useState("");
  const [debouncedQuery] = useDebounce(query, 300); // ✅ Debounced search input
  const users = useSelector((state) => state.users.users);
  const [force, setForce] = useState(1);

  const change = () => {
    setForce((state) => state + 1);
  };

  const statusHandler = (e) => {
    setStatus(e.target.value);
  };

  // ✅ Memoized filtering and sorting logic
  const filteredUsers = useMemo(() => {
    if (!users?.length) return [];

    // Sort once (ascending created_at)
    const sortedData = [...users].sort(
      (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );

    // Filter active users and apply search
    return sortedData.filter((std) => {
      if (std.status !== "active") return false;
      const search = debouncedQuery.toLowerCase();
      return (
        std.phone?.toString().toLowerCase().includes(search) ||
        std.name?.toLowerCase().includes(search)
      );
    });
  }, [users, debouncedQuery]);

  useEffect(() => {
    setState("Loading...");
  }, [force]);

  useEffect(() => {
    if (users?.length < 1) setState("No users found!");
  }, [users]);

  useEffect(() => {
    if (query != "") {
      setState("No matching users!");
    }
  }, [query]);

  let totalSms = 0;
  users?.map((user) => {
    if (user.notify == "stuck" || user.smsAmount < 11) return;
    totalSms += user?.smsAmount;
  });
  console.log(totalSms);
  console.log(filteredUsers);

  return (
    <>
      <div style={parentDivStyle}>
        <input
          type="text"
          placeholder="Search"
          style={searchStyle}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      <Table
        data={filteredUsers}
        change={change}
        state={state}
        columns={columns}
        url="users"
        name="User"
        showTransactions={(instance) => {
          props.showTransactions(instance);
        }}
        showCustomers={(instance) => {
          props.showCustomers(instance);
        }}
        showVendors={(instance) => {
          props.showVendors(instance);
        }}
        updateUser={(data) => props.updateUser(data)}
        sendUserSms={(data) => props.sendUserSms(data)}
        uploadModal={(data) => props.uploadModal(data)}
      />
    </>
  );
};

export default Users;
